import VGListener from "../project/src/vg";

document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	VGListener.onReady();
});


window.onTurboRender = function (callback) {
	document.addEventListener("turbo:render", (event) => {
		if (event.target?.hasAttribute('data-turbo-preview') === true) return;
		callback(event);
	});
};

window.onFrameRender = function (callback) {
	document.addEventListener("turbo:frame-render", (event) => {
		if (event.target?.hasAttribute('data-turbo-preview') === true) return;
		callback(event);
	});
}
